
const searchOverlay = document.getElementById('search-overlay');
const searchResults = document.getElementById('search-results');
const searchInput = document.getElementById('search-input');
const searchOverlayBackdrop = document.getElementById('search-overlay-backdrop');

const DEFAULT_TEXT = "Search for products";

// Toggle cart overlay
const toggleSearchOverlay = () => {
    searchOverlay.classList.toggle('hidden');
}

// Add event listeners for toggling cart overlay
document.querySelectorAll('.search-button').forEach(button => { button.addEventListener('click', toggleSearchOverlay) });
searchOverlayBackdrop.addEventListener('click', toggleSearchOverlay);

const renderSearchResults = async (products) => {
    let html = '';
    
    for(const key in products) {
        const product = products[key];
        const { metafields } = await fetch(window.Shopify.routes.root + `products/${product.handle}?view=metafields`)
        .then(response => {
            return response.json();
        })
        .catch(err => {
            console.log(`Error retrieving product ${product.handle} metadata:`, err);
            return null;
        })
        
        html += `
            <div class="text-[0] align-top px-2 w-1/2 sm:w-1/3 text-wrap snap-center items-start shrink-0 grow-0 pb-8">
                <a class="w-full m-0 group mb-2 sm:mb-0" href="/products/${product.handle}">
                    <div class="relative m-0 w-full aspect-4/3">
                        <img src="${product.images[0].src}" alt="Speedwork Glove Set (Black)" srcset="${product.images[0].src}&amp;width=352 352w, ${product.images[0].src}&amp;width=700 700w" width="700" height="1050" class="absolute top-0 left-0 w-full h-full object-cover transition-all duration-500 opacity-100">
                    </div>
                    <h5 class="font-body font-bold pt-8">${metafields?.title ?? product.title}</h5>
                    <span class="text-p-sm opacity-75 mt-2 inline-block">${metafields?.color ? metafields.color : ''}</span>
                    <div class="p-base font-body flex">
                        <span class="inline ${metafields?.color ? "pt-2" : "pt-8"} mr-2">${formatMoney(product.variants[0].price * 100)}</span>
                        <span class="text-red-600 inline ${metafields?.color ? "pt-2" : "pt-8"} line-through">${parseInt(product.variants[0].compare_at_price) > parseInt(product.variants[0].price) ? formatMoney(product.variants[0].compare_at_price * 100) : ''}</span>
                    </div>
                </a>
            </div>
        `;
    }
    
    searchResults.innerHTML = html;
}

const searchProducts = async () => {
    // Set loading spinner
    searchResults.innerHTML = `
        <div class="w-full h-full flex items-center justify-center">
            <div class="loading__spinner opacity-75" style="width: 10rem;">
                <svg
                    aria-hidden="true"
                    focusable="false"
                    class="spinner"
                    viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle class="path" fill="none" stroke-width="3" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        </div>
    `;
    searchResults.parentElement.classList.remove("hidden"); // Is hidden before first search
    
    const query = searchInput.innerHTML;
    
    if(query === DEFAULT_TEXT || query === "") {
        if(!searchInput.classList.contains('opacity-50')) searchInput.classList.add('opacity-50');
    } else {
        searchInput.classList.remove('opacity-50');
    }
    
    let data = JSON.parse(window.sessionStorage.getItem('searchData'));
    
    // Fetch and store data if not already loaded from session storage
    if(!data) {
        console.log("FETCHING FRESH DATA!");
        data = await fetch(`/products.json/?limit=250`)
        .then(response => {
            return response.json();
        })
        
        window.sessionStorage.setItem('searchData', JSON.stringify(data));
    }
    
    const { products } = data;
    
    renderSearchResults(products.filter(product => product.title.toLowerCase().includes(query.toLowerCase())));
}

searchInput.addEventListener('keypress', (e) => {
    if(e.key === "Enter") {
        e.preventDefault();
        searchProducts();
    }
});

// Handles clearing/setting placeholder text when search is focused/unfocused
const handleSearchClick = (e) => {
    const content = searchInput.innerHTML;
    
    if(content === DEFAULT_TEXT) {
        searchInput.innerHTML = "";
    } else if (content === "") {
        searchInput.innerHTML = DEFAULT_TEXT;
    }
}
searchInput.addEventListener('focusout', handleSearchClick);
searchInput.addEventListener('click', handleSearchClick);